/* @flow */

const Themes = {
  THEME_LIGHT: 'light',
  THEME_DARK: 'dark',
  THEME_AMG: 'amg',
  THEME_TRANSPARENT: 'transparent'
};

export default Themes;

export type $Theme = $Values<typeof Themes>;
